import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Form, TextArea } from 'semantic-ui-react'
import $ from "jquery";
import Server from '../../../functions/server'

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class MaxWidthDialog extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'sm',

  };

  componentDidMount() {
    this.getState();
  }

  componentDidUpdate(props) {
    if (props.followupId != this.props.followupId) {
      this.getState();
    }
  }

  getState() {
    let data = this.props.data;
    let date, remarks;
    data.map((z) => {
      if (this.props.followupId == z.id) {
        date = z.followup;
        remarks = z.remarks;
      }
    });
    this.setState({
      followup: date,
      remarks: remarks,
    })
  }

  submit() {
    let context = this;
    if (this.props.pendingrequestedit == 'none') {
      alert('Access Is Denied!!!');
      return;
    }
    let data1 = { 'followup': this.state.followup, 'remarks': this.state.remarks, 'id': this.props.followupId };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaserequest/updates.php',
      success: function(data)
      {
        let datas = context.props.data;
        if (data == 1) {
          datas.map((z) => {
            if (context.props.followupId == z.id) {
              z.followup = context.state.followup;
              z.remarks = context.state.remarks;
            }
          })
          context.props.getPurchaseRequest(1, context.props.orderElement, context.props.sortingOrder);
        }
        else {
          alert('Error!!!')
        }
        context.props.update(datas);
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  }

  render() {
    const { classes } = this.props;
    let followup = this.state.followup;
    let remark = this.state.remarks;
    return (
      <React.Fragment>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.props.openFollowup} onClose={ () => { this.props.handleClose() }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Edit Follow-Up and Remarks</DialogTitle>
          <DialogContent>
            <input type="date" id="date" value={followup} onChange={this.handleChange('followup')} />
            <Form>
              <br/>
              <TextArea placeholder='Remarks' value={remark} onChange={this.handleChange('remarks')} style={{ minHeight: 100 }} />
            </Form>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.submit.bind(this)} color="primary">
              Submit
            </Button>
            <Button onClick={ () => { this.props.handleClose() }} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

MaxWidthDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MaxWidthDialog);
